import { Grid } from '@material-ui/core';
import { EntityLayout } from '@backstage/plugin-catalog';
import { CustomGroupProfileCard } from '../cards/GroupProfileCard';
import { CustomOwnershipCard } from '../cards/OwnershipCard';
import { CustomMembersListCard } from '../cards/MembersListCard';
import { entityWarningContent } from '../shared/tabs';

export const groupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}><CustomGroupProfileCard variant="gridItem" /></Grid>
        <Grid item xs={12} md={6}><CustomOwnershipCard variant="gridItem" relationAggregation="aggregated" /></Grid>
        <Grid item xs={12} md={6}><CustomMembersListCard /></Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
